import React, { Component } from 'react'
import GeneralTab from './tabs/GeneralTab';
import AccountTab from './tabs/AccountTab';
import SecurityTab from './tabs/SecurityTab';
import { Tabs, Tab } from 'react-bootstrap';

class ProfileSettingsTabs extends Component {
    render() {
        return (
            <div className="profile-settings-tabs">
                <Tabs defaultActiveKey="general" id="profile-settings-tabs">
                    <Tab eventKey="general" title="General">
                        <ProfileSettingsTabs.General />
                    </Tab>
                    <Tab eventKey="account" title="Billing">
                        <ProfileSettingsTabs.Account />
                    </Tab>
                    <Tab eventKey="security" title="Security">
                        <ProfileSettingsTabs.Security />
                    </Tab>
                </Tabs>

            </div>
        )
    }
}

ProfileSettingsTabs.General = GeneralTab;
ProfileSettingsTabs.Account = AccountTab;
ProfileSettingsTabs.Security = SecurityTab;

export default ProfileSettingsTabs
